'use strict';

var publicPath = 'https://global.zuzuche.com/static/analytics/dist/1.0.0/za.js';

var nameSpace = 'zaDataLayer';
var win = window;
win[nameSpace] = win[nameSpace] || [];
win.za = function () {
    win[nameSpace].push(arguments);
};
var doc = document;
var head = doc.head || doc.getElementsByTagName('head')[0] || doc.documentElement;
var node = doc.createElement('script');
node.async = true;
node.src = publicPath;
head.appendChild(node);



//////////////////
// WEBPACK FOOTER
// ./node_modules/zzc-analytics/lib/za-input.js
// module id = 351
// module chunks = 49